@for (modalInputs of modalsInputs; track modalInputs.id) {
  <ng-container *ngComponentOutlet="modalClass; inputs: getModalInputs(modalInputs)"></ng-container>
}
